import { Message } from '@flos/react-ui';
import type { LocalDateDTO } from 'gw-edge-client/dist/types/dto/pc/edge/time';
import { convertLocalDateDTOToDate, convertLocalDateToString } from '../../../utils/dateUtil';
import { useHippoText } from '../../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import { opcInfoAtom } from '../../../recoil/atoms/opcInfoAtom';
import { getAddCoverageHighlightNote } from '../config/AddCoverageConfig';
import type { HighlightNoteContent } from '../types';
import { getRemoveCoverageHighlightNote } from '../config/RemoveCoverageConfig';

const HighlightInfoForCoverage = ({
    coverageId,
    shouldHide = false,
    editCoverageType,
    renewalDate,
    coverageName = '',
    coverageSubtitle = '',
    flavourName = ''
}: {
    coverageId: string;
    shouldHide?: boolean;
    editCoverageType: 'add' | 'remove';
    renewalDate?: LocalDateDTO;
    coverageName?: string;
    coverageSubtitle?: string;
    flavourName?: string;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const policyRenewalDate = convertLocalDateToString(
        convertLocalDateDTOToDate(renewalDate ?? {})
    );
    const { isFromDAFlow } = useRecoilValue(opcInfoAtom);

    const getHighlightNoteForModal = (
        coverageId: string,
        _renewalDate: string,
        _coverageName: string
    ): HighlightNoteContent | undefined => {
        if (editCoverageType === 'add')
            return getAddCoverageHighlightNote(
                coverageId,
                coverageSubtitle,
                flavourName,
                _renewalDate,
                getHippoText
            );
        if (editCoverageType === 'remove')
            return getRemoveCoverageHighlightNote(
                coverageId,
                _coverageName,
                _renewalDate,
                isFromDAFlow ?? false,
                getHippoText
            );
    };

    const highlightNote = getHighlightNoteForModal(
        coverageId,
        policyRenewalDate ?? '',
        coverageName
    );

    if (!highlightNote || shouldHide) return <></>;

    return (
        <div className="u-display-flex u-gap-7 u-flex-column u-flex-items-stretch">
            <Message
                theme={highlightNote.theme === 'info' ? undefined : highlightNote.theme}
                title={<strong>{highlightNote?.noteTitle ?? ''}</strong>}
            >
                <div dangerouslySetInnerHTML={{ __html: highlightNote?.noteText }} />
            </Message>
            <div dangerouslySetInnerHTML={{ __html: highlightNote?.noteDescription ?? '' }} />
        </div>
    );
};
export default HighlightInfoForCoverage;
